import React, { useState, useEffect } from "react";
import { array, string } from "prop-types";

import CustomStoryCard6 from "../../../molecules/CustomStoryCard6";
import DfpAd from "../../../dfp-ad";

import "./organism1.m.css";

const Organism1 = ({ stories, collectionSlug }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(global.deviceWidth < 875);
  }, []);

  return (
    <div styleName="four-col-story">
      {stories.slice(0, 4).map((story, index) => (
        <CustomStoryCard6
          key={index}
          story={story}
          imageType={isMobile ? "image4x3" : "image16x9"}
          aspectRatio={isMobile ? [4, 3] : [16, 9]}
          isStoryMetaData={!isMobile}
          updatedFont={true}
        />
      ))}

      <div styleName="horizontal-ad">
        <DfpAd adtype="News_728x90_T1" collectionSlug={collectionSlug} layoutName="BigPhotoStoryCardSlider1Ad" />
      </div>
    </div>
  );
};

Organism1.propTypes = {
  stories: array,
  className: string,
  collectionSlug: string
};

export default Organism1;
